import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ftybeqju6j: FaireBrandEntity = {
  token: "b_ftybeqju6j",
  type: "brand",
  name: "We Must Mustard",
  avatarUrl:
    "https://cdn.faire.com/fastly/25c76295d00bc84215162f61c8e68d440c7037f43685483b65f5f5547252546b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2cde2a4b26c8fb7acf951b6f867b04216e96aefb5a467dbb5412ec9dd4734496.png",
  logoUrl:
    "https://cdn.faire.com/fastly/25c76295d00bc84215162f61c8e68d440c7037f43685483b65f5f5547252546b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2cde2a4b26c8fb7acf951b6f867b04216e96aefb5a467dbb5412ec9dd4734496.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 94,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Courtney Yones started by making dipping mustard for her friends and loved ones. When they kept coming back for more, it became clear that this dipping mustard deserves to be shared. Believing in eating well and doing good, Courtney refined the recipe through 14 iterations and partnered with the OSU Food Innovation Center. What started with her son’s love of mustard grew into a woman-owned and operated business, making mustard with the kind of care that you’d give your own family.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:07.617Z",
    importedBy: "entity-db-cli",
  },
};
